/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Card, Theme } from '@nexigendigital/nxui'
import { useAppSelector } from 'store/hooks'

import BillingDetails from 'containers/shop/checkout/billingDetails'
import OrderTotal from 'containers/shop/checkout/orderTotal'
import CartEmpty from 'containers/shop/cart/cartEmpty'
import OrderItems from 'containers/shop/checkout/orderItems'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function CartConfirmation() {
    const { items } = useAppSelector((state) => state.shop)

    return (
        <StyledCartConfirmation>
            <Card title={'Cart'}>
                {items.length === 0 ? <CartEmpty/> : <OrderItems/>}
            </Card>
            <Billing>
                <BillingDetails/>
                <OrderTotal/>
            </Billing>
        </StyledCartConfirmation>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledCartConfirmation = styled.section`
    display: grid;
    gap: 25px;

    > article {
        &:first-child {
            ${props => (Theme.Functions.mediaBreakDown(props.theme['breakpoints-sm']))} {
                margin-top: 24px;
            }
        }

        > div {
            display: flex;
            justify-content: center;
        }
    }
`

const Billing = styled.section`
    display: flex;
    gap: 24px;

    ${props => (Theme.Functions.mediaBreakDown(props.theme['breakpoints-sm']))} {
        flex-direction: column;
    }

    > div {
        width: 100%;
    }
`
